import {
  presentIllnessOptions,
  surgicalTreatmentOptions,
} from "../../../IpEMR/Options/historyOptions";

export const MEDICAL_MANAGEMENT_FALLBACK = "Medical Management";

const ENTRY_SEPARATOR = "; ";

const trimmed = (value) =>
  value === null || value === undefined ? "" : String(value).trim();

const othersEntries = (list) => {
  if (!Array.isArray(list)) return [];
  return list
    .map((item) =>
      trimmed(item && typeof item === "object" ? item.remarks : item)
    )
    .filter(Boolean);
};


const checklistEntries = (options, source, othersKey, othersListKey) => {
  if (!source) return [];
  const entries = [];
  options.forEach((option) => {
    if (!source[option.value]) return;
    if (option.value === othersKey) {
      entries.push(...othersEntries(source[othersListKey]));
      return;
    }
    const description = trimmed(source[`${option.value}_description`]);
    entries.push(description ? `${option.label}-${description}` : option.label);
  });
  return entries;
};


export const getPresentIllnessSummary = (history) =>
  checklistEntries(
    presentIllnessOptions,
    history,
    "illness_others",
    "present_illness_others"
  ).join(ENTRY_SEPARATOR);

export const getSurgicalTreatmentSummary = (history) => {
  const summary = checklistEntries(
    surgicalTreatmentOptions,
    history?.treatment_history,
    "surgical_others",
    "surgical_treatment_others"
  ).join(ENTRY_SEPARATOR);
  return summary || MEDICAL_MANAGEMENT_FALLBACK;
};


export const getPrimaryConsultantHospital = (...sources) => {
  for (const source of sources) {
    const consultants =
      source?.primary_consultant_details ??
      source?.data?.primary_consultant_details;
    if (!Array.isArray(consultants)) continue;
    const hospital = consultants
      .map((consultant) => trimmed(consultant?.primary_consultant_hospital))
      .find(Boolean);
    if (hospital) return hospital;
  }
  return "";
};
